import { render, staticRenderFns } from "./EducationTableProgram.vue?vue&type=template&id=e8b806a6"
import script from "./EducationTableProgram.vue?vue&type=script&lang=js"
export * from "./EducationTableProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports